import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
export var LOYALTY_FEES_REQUESTED = 'LOYALTY_FEES_REQUESTED';
export var LOYALTY_FEES_SUCCESS = 'LOYALTY_FEES_SUCCESS';
export var LOYALTY_FEES_ERROR = 'LOYALTY_FEES_ERROR';
export var getOperatorLoyaltyFeeConfigs = function getOperatorLoyaltyFeeConfigs(omsId) {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var OMSId, loyaltyFeeConfigs;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              OMSId = getState().user.userInfo.OMSId || omsId;
              dispatch(loyaltyFeesRequested());
              loyaltyFeeConfigs = void 0;
              _context.prev = 3;
              _context.next = 6;
              return dispatch(callAPI('GetOperatorLoyaltyFeeConfigsForOms', {
                OMSId: OMSId
              }));
            case 6:
              loyaltyFeeConfigs = _context.sent;
              if (loyaltyFeeConfigs.length > 0) {
                dispatch(loyaltyFeesSuccess(loyaltyFeeConfigs));
              } else {
                dispatch(loyaltyFeesError(loyaltyFeeConfigs));
              }
              _context.next = 13;
              break;
            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](3);
              dispatch(loyaltyFeesError(loyaltyFeeConfigs));
            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this, [[3, 10]]);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var loyaltyFeesRequested = function loyaltyFeesRequested() {
  return {
    type: LOYALTY_FEES_REQUESTED
  };
};
export var loyaltyFeesSuccess = function loyaltyFeesSuccess(payload) {
  return {
    type: LOYALTY_FEES_SUCCESS,
    payload: payload
  };
};
export var loyaltyFeesError = function loyaltyFeesError(payload) {
  return {
    type: LOYALTY_FEES_ERROR,
    payload: payload
  };
};